import { useCallback, useEffect, useMemo, useState } from 'react';
import { getStorageUrlCandidates } from '../utils/storageUrl';

/**
 * Resolve storage paths with automatic fallback when the first URL 404s.
 * Use with Avatar imgProps or <img onError={onError} />.
 */
export function useStorageImageSrc(path) {
  const candidates = useMemo(() => getStorageUrlCandidates(path), [path]);
  const [index, setIndex] = useState(0);

  useEffect(() => {
    setIndex(0);
  }, [path, candidates]);

  const onError = useCallback(() => {
    setIndex((current) => (current < candidates.length - 1 ? current + 1 : current));
  }, [candidates.length]);

  return {
    src: candidates[index] || undefined,
    onError,
  };
}
